import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { useId } from '../../hooks';
import { callAll } from '../../utils';
import { useDropdown } from './Context';
import { CLOSE_MENU, REGISTER_ITEM, UNREGISTER_ITEM } from './constants';
const Item = forwardRef(({ as: Element = 'li', children, className, disabled = false, onClick = () => { }, render, ...rest }, ref) => {
    var _a;
    const { dispatch, getItemId, items, activeItemIndex, isNavigatingWithKeyboard } = useDropdown();
    const uniqId = useId();
    const itemId = getItemId(uniqId);
    const internalRef = useRef(null);
    const isFocused = activeItemIndex !== null && ((_a = items[activeItemIndex]) === null || _a === void 0 ? void 0 : _a.id) === itemId;
    const close = () => {
        dispatch({ type: CLOSE_MENU });
    };
    useImperativeHandle(ref, () => internalRef.current);
    useEffect(() => {
        if (!disabled) {
            dispatch({ type: REGISTER_ITEM, id: itemId, element: internalRef.current });
        }
        return () => {
            dispatch({ type: UNREGISTER_ITEM, id: itemId });
        };
    }, [disabled, dispatch, itemId]);
    const handleClick = evt => {
        if (disabled) {
            evt.preventDefault();
            return;
        }
        close();
    };
    return (_jsx(Element, { "aria-disabled": disabled, className: className, "data-disabled": disabled, "data-focus": isFocused, "data-pointer-disabled": isNavigatingWithKeyboard, id: itemId, onClick: callAll(onClick, handleClick), ref: internalRef, role: "menuitem", tabIndex: -1, ...rest, children: render ? render({ close, isFocused }) : children }));
});
Item.displayName = 'Item';
export { Item };
//# sourceMappingURL=Item.js.map